document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".privacy-tab-button");
  const tabSections = document.querySelectorAll(".privacy-section");
  const privacyTitle = document.querySelector(".privacy-title");


  function activateTab(tabSlug) {
    // Remove active classes
    tabButtons.forEach(btn => btn.classList.remove("active"));
    tabSections.forEach(sec => sec.classList.remove("active"));

    // Find button & section
    const button = Array.from(tabButtons).find(
      btn => btn.dataset.tab.toLowerCase() === tabSlug.toLowerCase()
    );
    const section = document.getElementById(`tab-${tabSlug}`);
    if (button && section) {
      button.classList.add("active");
      section.classList.add("active");

      // Update title without SVG
      const titleContent = button.querySelector('.privacy-tab-button__content')?.textContent;
      if (privacyTitle && titleContent) {
        privacyTitle.textContent = titleContent.trim();
      }
    }
  }

  // Parse query string for ?tab=privacy
  const urlParams = new URLSearchParams(window.location.search);
  const initialTab = urlParams.get('tab') || tabButtons[0]?.dataset.tab;

  if (initialTab) activateTab(initialTab);

  // Click events
  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      const tabSlug = button.dataset.tab;
      activateTab(tabSlug);

      // Update URL query string without reload
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('tab', tabSlug);
      history.replaceState(null, '', newUrl.toString());
    });
  });
});